module.exports = __webpack_public_path__ + "img/foto_5.b47cb9df.jpg";